export default {
  title: '¿Seguro que quieres eliminar tu cuenta?',
  description:
    'Esta acción es permanente. Perderás el acceso a tus pedidos, puntos de fidelidad y preferencias guardadas.',
  labels: {
    loading: 'Eliminando tu cuenta...',
  },
  buttons: {
    confirm: 'Confirmar',
    cancel: 'Cancelar',
  },
  toasts: {
    success:
      'Tu cuenta ha sido eliminada permanentemente. Ya no tienes acceso a tu historial de pedidos, puntos de fidelidad ni datos guardados.',
    error:
      'Algo salió mal. Por favor, inténtalo de nuevo. Si el problema persiste, contacta a nuestro equipo de soporte: {{supportEmail}}',
  },
};
